<mat-card>
  <mat-card-header class="full-width-header">
    <mat-card-title>
      <div class="title-row">
        <span>{{ 'AI_ASSISTANT.SETTINGS.PROFILE_CAPABILITY.TITLE' | translate }}</span>
        @if (hasUnsavedChanges()) {
          <span class="unsaved-changes-text">
            {{ 'AI_ASSISTANT.SHARED.UNSAVED_CHANGES.TITLE' | translate }}
          </span>
        }
      </div>
    </mat-card-title>
  </mat-card-header>
  <mat-accordion displayMode="flat" togglePosition="after" multi>
    @for (
      personalityCapabilityForm of personalityCapabilityForms();
      track personalityCapabilityForm;
      let iPersonalityCapability = $index;
      let isLast = $last
    ) {
      <mat-expansion-panel>
        <mat-expansion-panel-header collapsedHeight="auto" expandedHeight="auto" class="panel-header">
          <div class="ai-profile-content">
            <div class="titles">
              <mat-panel-title>
                {{ 'AI_ASSISTANT.SETTINGS.PROFILE_CAPABILITY.PURPOSE.TITLE' | translate }}
                @if (personalityCapabilityForm.isOverride()) {
                  <glxy-badge [color]="'blue'" size="small" class="custom-badge">
                    {{ 'AI_ASSISTANT.SHARED.MODIFIED' | translate }}
                  </glxy-badge>
                }
              </mat-panel-title>
              <mat-panel-description class="description">
                {{ 'AI_ASSISTANT.SETTINGS.PROFILE_CAPABILITY.PURPOSE.HELP_TEXT' | translate }}
              </mat-panel-description>
            </div>
            @if (personalityCapabilityForm.isOverride()) {
              <button
                mat-icon-button
                class="menu-button"
                title="{{ 'AI_ASSISTANT.SETTINGS.ROLLBACK' | translate }}"
                (click)="handleRollbackClicked(personalityCapabilityForm, $event)"
              >
                <mat-icon>undo</mat-icon>
              </button>
            }
          </div>
        </mat-expansion-panel-header>
        <!-- Personality Capability Prompt(s) -->
        @let promptModuleForms = personalityCapabilityForm.controls.promptModules;
        @if (promptModuleForms && promptModuleForms.length > 0) {
          @for (promptModuleForm of promptModuleForms.controls; track promptModuleForm; let iPromptModule = $index) {
            @if (promptModuleForm && promptModuleForm.controls.instructions) {
              <glxy-form-field [formGroup]="promptModuleForm">
                <textarea
                  matInput
                  formControlName="instructions"
                  cdkTextareaAutosize
                  cdkAutosizeMinRows="5"
                  cdkAutosizeMaxRows="20"
                ></textarea>
                <glxy-hint>
                  {{ 'AI_ASSISTANT.SETTINGS.PROFILE_CAPABILITY.PURPOSE.PROFILE_PROMPT_HINT' | translate }}
                </glxy-hint>
              </glxy-form-field>
            }
          }
        }
      </mat-expansion-panel>
      @if (!isLast) {
        <mat-divider />
      }
    }

    @if (assistantSupportsVoice()) {
      <mat-divider />
      <mat-expansion-panel>
        <mat-expansion-panel-header collapsedHeight="auto" expandedHeight="auto" class="panel-header">
          <div class="ai-profile-content">
            <div class="titles">
              <mat-panel-title>
                {{ 'AI_ASSISTANT.SETTINGS.PROFILE_CAPABILITY.SPEECH.TITLE' | translate }}
              </mat-panel-title>
              <mat-panel-description class="description">
                {{ 'AI_ASSISTANT.SETTINGS.PROFILE_CAPABILITY.SPEECH.HELP_TEXT' | translate }}
              </mat-panel-description>
            </div>
          </div>
        </mat-expansion-panel-header>
        @let _voiceConfigForm = voiceConfigForm();
        @if (_voiceConfigForm) {
          <ai-voice-configuration-form [voiceConfigForm]="_voiceConfigForm" />
        }
      </mat-expansion-panel>
    }

    <!-- Generative AI Panel -->
    @if (!assistantSupportsVoice()) {
      <mat-divider />
      <mat-expansion-panel>
        <mat-expansion-panel-header collapsedHeight="auto" expandedHeight="auto" class="panel-header">
          <div class="ai-profile-content">
            <div class="titles">
              <mat-panel-title>
                {{ 'AI_ASSISTANT.SETTINGS.PROFILE_CAPABILITY.MODEL.TITLE' | translate }}
              </mat-panel-title>
              <mat-panel-description class="description">
                {{ 'AI_ASSISTANT.SETTINGS.PROFILE_CAPABILITY.MODEL.HELP_TEXT' | translate }}
              </mat-panel-description>
            </div>
          </div>
        </mat-expansion-panel-header>
        @let _modelConfigForm = modelConfigForm();
        @let _availableModels = availableModels();
        @if (_modelConfigForm && _availableModels) {
          <ai-model-configuration-form [aiModelConfigForm]="_modelConfigForm" [availableModels]="_availableModels" />
        }
      </mat-expansion-panel>
    }
  </mat-accordion>
</mat-card>
